exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title-toolbar[data-v-3f809752]{padding:0 20px!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/PriviledgesView.vue"],"names":[],"mappings":"AACA,gCACE,wBAA2B,CAC5B","file":"PriviledgesView.vue","sourcesContent":["\n.title-toolbar[data-v-3f809752] {\n  padding: 0 20px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3f809752","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/PriviledgesView.vue
// module id = 1375
// module chunks = 10